/**
 * Reject Enrollment Dialog (iter271 — extracted from Enrollments.js).
 * Captures a mandatory rejection reason that gets emailed to the parent.
 */
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from '../../../components/ui/dialog';
import { Button } from '../../../components/ui/button';
import { Label } from '../../../components/ui/label';
import { Textarea } from '../../../components/ui/textarea';
import { X } from 'lucide-react';

export default function RejectEnrollmentDialog({
  open,
  onOpenChange,
  selectedEnrollment,
  rejectReason,
  setRejectReason,
  onConfirm,
}) {
  return (
    <Dialog
      open={open}
      onOpenChange={(o) => {
        onOpenChange(o);
        if (!o) setRejectReason('');
      }}
    >
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl flex items-center gap-2">
            <X className="h-5 w-5 text-rose-500" />
            Reject Enrollment
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 mt-4">
          <div className="p-3 bg-slate-50 rounded-lg">
            <p className="font-medium text-slate-900">{selectedEnrollment?.player_name}</p>
            <p className="text-sm text-slate-500">Program: {selectedEnrollment?.program_name}</p>
            <p className="text-sm text-slate-500">Parent: {selectedEnrollment?.parent_name}</p>
          </div>

          <div className="p-3 bg-amber-50 border border-amber-200 rounded-lg">
            <p className="text-sm text-amber-800">
              The parent will receive an email notification with the rejection reason.
            </p>
          </div>

          <div className="space-y-2">
            <Label className="text-rose-600">Rejection Reason *</Label>
            <Textarea
              value={rejectReason}
              onChange={(e) => setRejectReason(e.target.value)}
              placeholder="Please explain why this enrollment is being rejected..."
              rows={4}
              className="border-rose-200 focus:border-rose-400"
              data-testid="reject-reason-input"
            />
            <p className="text-xs text-slate-500">This reason will be sent to the parent.</p>
          </div>

          <DialogFooter className="flex justify-end gap-3 pt-4">
            <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
            <Button
              className="bg-rose-500 hover:bg-rose-600"
              onClick={() => onConfirm(selectedEnrollment?.id)}
              disabled={!rejectReason.trim()}
              data-testid="confirm-reject-btn"
            >
              <X className="h-4 w-4 mr-1" />
              Reject Enrollment
            </Button>
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  );
}
